import { createContext } from 'react'

export type UserContextType = {
  businessPartner: BusinessPartner
  businessPartnerId: string
  clearUser: () => void
  getUser: () => Promise<void>
  isActiveB2BUser: boolean
  isPartnerAssociationActive: boolean
  isUserLoading: boolean
  user: Partial<User>
}

const userInitial: UserContextType = {
  businessPartner: null,
  businessPartnerId: null,
  clearUser: () => null,
  getUser: () => null,
  isActiveB2BUser: false,
  isPartnerAssociationActive: false,
  isUserLoading: true,
  user: {},
}

const UserContext = createContext(userInitial)

export default UserContext
